module.exports = __webpack_public_path__ + "static/media/emoji-confused-face.11171358.png";